import { QueryFactory } from "../../../../Common";
import { Captor } from "../../../../Contracts";
export const QAnnualReport = QueryFactory(Captor.QueryTypes.AnnualReport);
//# sourceMappingURL=QAnnualReport.js.map